import { FC, useEffect, useState } from 'react';
import { AuthorityType, IPluginPromptData } from '../../../libs/models/studio/PluginPromptList';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import AionuCreateProfile from './AIONUCreateProfile';
import AionuCreateReg from './AionuCreateReg';

interface AionuCreateFormProps {
  formData: IPluginPromptData;
  setFormData: React.Dispatch<React.SetStateAction<IPluginPromptData>>;
}

const AionuCreateForm: FC<AionuCreateFormProps> = ({ formData, setFormData }) => {
  const { user } = useAppSelector((state: RootState) => state.users);
  const [auth, setAuth] = useState<AuthorityType>(AuthorityType.Owner);

  useEffect(() => {
    const auth = formData.managedMembers?.find((m) => m.user.userId == user.userId);
    if (auth) {
      setAuth(auth.authorityType);
    } else {
      setAuth(AuthorityType.Contributor);
    }
  }, [user, formData]);

  return (
    <>
      <div className="aionu-form">
        <div className="form-panel">
          <AionuCreateProfile formData={formData} setFormData={setFormData} />
        </div>
        <div className="form-panel">
          <AionuCreateReg formData={formData} setFormData={setFormData} authority={auth} />
        </div>
      </div>
    </>
  );
};

export default AionuCreateForm;
